import { Stack, useTheme } from '@mui/material';

import { CoteamLogo } from 'src/assets/CoteamLogo';
import { ToggleRoleButton } from 'src/layouts/dashboard/navbar/ToggleRoleButton';
import { RoleNavbar } from 'src/layouts/dashboard/navbar/Navbar';
import { HelpButton } from 'src/layouts/dashboard/navbar/HelpButton';
import { NavbarAdminContents } from 'src/layouts/dashboard/navbar/admin/NavbarAdminContents';
import { OpinionButton } from 'src/layouts/dashboard/navbar/OpinionButton';
import { AccountPopover } from 'src/layouts/dashboard/navbar/AccountPopover';
import { useOrganization } from 'src/contexts/OrganizationContext';

type Props = {
  setRole: React.Dispatch<React.SetStateAction<RoleNavbar>>;
};
export const NavbarAdminMenu = ({ setRole }: Props) => {
  const { currentUser, isLoading } = useOrganization();
  const theme = useTheme();

  // ローディング中は基本構造のみ表示
  if (isLoading) {
    return (
      <Stack
        sx={{
          px: '16px',
          height: '100%',
          backgroundColor: theme.palette.surface.sidebarDark,
        }}
      >
        <Stack sx={{ py: '16px' }}>
          <CoteamLogo />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack
      sx={{
        px: '16px',
        height: '100%',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.surface.sidebarDark,
      }}
    >
      <Stack
        sx={{
          py: '16px',
          height: '100%',
          justifyContent: 'space-between',
          overflowY: 'scroll',
          '&::-webkit-scrollbar': {
            width: 0,
            height: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'transparent',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        <Stack gap="16px">
          <CoteamLogo />
          <NavbarAdminContents />
        </Stack>
      </Stack>
      {currentUser && (
        <Stack gap="8px">
          <OpinionButton role="admin" />
          <HelpButton role="admin" />
          <ToggleRoleButton role="admin" setRole={setRole} />
          <AccountPopover role="admin" />
        </Stack>
      )}
    </Stack>
  );
};
